<template>
  <div class="profile-header">

    <div class="relative">
      <div class="cover-container rounded-t-lg">
        <img
          :src="data.bannerUrl"
          alt="user-profile-cover"
          class="responsive block hover-dim"
          style="min-height: 200px"
        >
        <upload-image-icon
          @upload-success="data.bannerUrl = $event"
          class="p-top-right"
        />
      </div>
      <div class="profile-img-container pointer-events-none">
        <div class="relative">
          <vs-avatar
            class="user-profile-img"
            :src="data.logoUrl"
            size="85px"
          />
        </div>
      </div>
    </div>

    <div class="flex items-center justify-end flex-wrap profile-header-nav p-6">
      <div class="slide-menu">
        <a
          href="#"
          v-for="i in menus"
          :key="i"
          :class="activeMenu == i ? 'text-primary' : 'text-dark'"
          @click.prevent="$emit('menu-changed', i)"
        >{{ i }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeMenu: {
      type: String,
      default: ''
    },
    menus: {
      type: Array,
      default: () => []
    },
    bannerUrl: {
      type: String,
      default: ''
    },
    logoUrl: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {
        return {
          bannerUrl: '',
          logoUrl: ''
        }
      }
    }
  },
  data () {
    return {
      showModal: false
    }
  },

}
</script>

<style lang="scss">
.slide-menu {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;

  a {
    font-size: 1rem;
    padding: 0.5rem 1rem;
  }
}

.p-top-right {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 1001;
}

.hover-dim:hover {
  background-color: #000;
  filter: brightness(0.2);
  transition: all 0.3s ease;
}
.hover-dim {
  transition: all 0.3s ease;
}
</style>
